import React from 'react'
import classNames from 'classnames'
import {Theme} from '@/constants'
import {COMPANY_LOGO_LIGHT_PATH, COMPANY_LOGO_PATH, COMPANY_NAME, COMPANY_SITE} from '@/constants/app'
import {LogoProps} from './props'
import styles from './styles.scss'

import {LOGO} from '@/constants/playwright-ids'

export const Logo: React.FC<LogoProps> = (props) => {
    const {
        type,
        className,
        logoLight = COMPANY_LOGO_LIGHT_PATH,
        logoDark = COMPANY_LOGO_PATH,
        altTitle = COMPANY_NAME,
        href = COMPANY_SITE,
        isBlank = true,
        onClick
    } = props

    const logo = React.useMemo((() => {
        switch (type) {
            case Theme.DARK:
                return logoLight
            case Theme.LIGHT:
                return logoDark
            default:
                return null
        }
    }), [type, logoLight, logoDark])

    if (!logo) return null

    return (
        <a
            data-test-id={LOGO}
            onClick={onClick}
            href={onClick ? undefined : href}
            className={classNames(styles.root, className)}
            target={isBlank ? '_blank' : ''}
            rel='noreferrer'
        >
            <img src={logo} alt={altTitle} className={classNames(styles.img)} />
        </a>
    )
}
